import React, { Component, useState, Fragment } from "react";
import Cookies from 'js-cookie'
import Switch from 'react-bootstrap/Switch';
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';

import {addTeigiFunction} from '../cm_parts/js/TeigiFunction';
import settings from '../../settings.json';
import '../cm_parts/css/teigi.css';


export default class Settings extends Component{
  state={
    authObj:{},
    settings_list:[],
    checked_isit_auto_import_data:true,
    checked_isit_auto_import_data_fix:null
  }


  componentDidMount () {
    let my_token = Cookies.get('_replace_token');
    if(my_token===undefined){
      window.location.href = '/login';
    }


    let staff_token = Cookies.get('_replace_token');
		let staff_name = Cookies.get('_replace_staff');
		this.setState({authObj:{"token":staff_token, "name":staff_name}})

    let settings_list = addTeigiFunction.getSettingsList(staff_token, staff_name);
    this.setState({settings_list:settings_list});
    {settings_list.map((row, index)=>{
      if(row['key_data']==='isit_auto_import_data'){
        if(row['val_data']==='auto'){
          this.setState({checked_isit_auto_import_data:true});
          this.setState({checked_isit_auto_import_data_fix:true});
        }else{
          this.setState({checked_isit_auto_import_data:false});
          this.setState({checked_isit_auto_import_data_fix:false});
        }
      }
    })}
    
    //console.dir(this.props.adamin_member);
  }



  handleChange = (e) => {
    //console.dir(e);
    this.setState({ checked_isit_auto_import_data: !this.state.checked_isit_auto_import_data });
  }


  render(){

    const handleSubmitSettingsButton = async (e) => {
      
      let _obj = {};
      for (let i = 0; i < e.target.length; i++) {
        if(e.target[i].name==='' || e.target[i].name===null){
          continue;
        }
        console.dir(e.target[i]);
        if(e.target[i].name==='isit_auto_import_data' && e.target[i].checked){
          _obj[e.target[i].name] = 'auto';
        }else{
          _obj[e.target[i].name] = 'not_auto';
        }
      }
      console.dir(_obj);

      let settings_list = addTeigiFunction.changeSettingsData(_obj, this.state.authObj);
      e.preventDefault();
    }


    return (
      <Form onSubmit={handleSubmitSettingsButton} className="teigi-area" >

        <div className="board-area mb-5 px-3 py-2 teigi-table"  >
          <div className="row align-item-center logo-area " >
            <a href="/cm-list" className="col-1"><img className=" top-logo" src={"./images/logo192.jpg"} /></a>
            {this.props.adamin_member.includes(this.state.authObj.name) ? 
              <>
                <div className="col-1 "><a href="/cm-list-teigi">定義</a></div>
                <div className="col-1 ">その他設定</div>
              </> 
            : <></>}

          </div>

			  	<table>
			  		<thead>
			  			<tr className="table-row sticky-top bg-secondary text-white">
			  				<td className="table-col nowrap">項目名</td>
                <td className="table-col nowrap">設定値</td>
                <td className="table-col nowrap bg-primary text-white">変更値</td>
			  			</tr>
			  		</thead>

            <tbody>
              {this.state.settings_list.map((row, index)=>{
                return(
                  <tr className="table-row" key={index}>
                    <td className="table-col nowrap">在庫情報自動取り込み</td>
                    <td className="table-col nowrap">
                      {this.state.checked_isit_auto_import_data_fix ? <>ON</> : <>OFF</>}
                    </td>
                    <td className="table-col nowrap">
                      <InputGroup size="sm" className="mb-3 setting-switch-flex">
                        OFF
                        <Switch
                          className="mx-2"
                          checked={this.state.checked_isit_auto_import_data}
                          onChange={this.handleChange}
                          name='isit_auto_import_data'
                        />
                        ON
                      </InputGroup>
                    </td>
                  </tr>

                )
              })}



              {/*
              {this.state.settings_list.map((row, index)=>{
                

                return(
                  <>
                    <tr key={'s_'+row.id} className='table-row'>
                      <td className="table-col nowrap ">{row.id}</td>
                      <td className="table-col nowrap ">{row.tonya_name_f}</td>
                    </tr>
                  
                  </>


                )


              })}
              */}

            </tbody>
          </table>

            <Button variant="primary" id="" size="sm" type="submit" className="mt-2">
							変更する
						</Button>
        </div>
      </Form>
    );
  }
}

